<template>
  <div class="relative bg-gradient-to-r from-purple-600 to-blue-600 h-screen text-white overflow-hidden">
  <div class="absolute inset-0">
    <img src="/img/bckg.jpg" alt="Background Image" class="object-cover object-center w-full h-full" />
    <div class="absolute inset-0 bg-black opacity-50"></div>
  </div>
  
  <div class="relative flex flex-col justify-center items-center h-full text-center">
    <h1 class="text-5xl font-bold leading-tight mb-4">Bonjour</h1>
    <p class="text-lg text-gray-300 mb-8">Je m'appelle Maxime Stawski.</p>
    
  </div>
</div>
</template>
<script>
export default {
  name: 'ComponentHero',
}
</script>